<template>
  <section
    ref="row3"
    class="pi-pd-bottom-100 pi-justify-center pi-align-center row-3"
  >
    <div
      class="row-3-left"
      :class="
        isMobile || show ? 'animate__animated animate__fadeInLeft' : 'hide'
      "
    >
      <div
        class="pi-align-center pi-justify-between pi-pd-bottom-50"
        style="width: 330px"
      >
        <div class="biz-data pi-flex-column">
          <div class="red pi-fz-54 pi-text-left pi-align-end">
            <div><DigitRoll :rollDigits="23" v-if="show" /></div>
            <span class="pi-fz-24 pi-lh-77 pi-fw-600">年</span>
          </div>
          <div class="biz-name pi-fz-16">软件研发中心运营经验</div>
        </div>
        <div class="biz-data pi-flex-column">
          <div class="red pi-fz-54 pi-text-left pi-align-end">
            <div><DigitRoll :rollDigits="200" v-if="show" /></div>
            <span class="pi-fz-24 pi-lh-77">+</span>
          </div>
          <div class="biz-name pi-fz-16 pi-text-left" style="text-indent: 10px">
            累计客户
          </div>
        </div>
      </div>

      <div class="pi-align-center pi-justify-between" style="width: 330px">
        <div class="biz-data pi-flex-column">
          <div class="red pi-fz-54 pi-text-left pi-align-end">
            <div><DigitRoll :rollDigits="2000" v-if="show" /></div>
            <span class="pi-fz-24 pi-lh-77">+</span>
          </div>
          <div class="biz-name pi-fz-16 pi-text-left" style="text-indent: 10px">
            累计项目
          </div>
        </div>
        <div class="biz-data pi-flex-column">
          <div class="red pi-fz-54 pi-text-left pi-align-end">
            <span class="pi-fz-24 pi-lh-77 pi-fw-600">CMMI</span>
            <div><DigitRoll :rollDigits="5" v-if="show" /></div>
          </div>
          <div class="biz-name pi-fz-16 pi-text-left" style="text-indent: 5px">
            权威认证
          </div>
        </div>

        <!-- <div class="biz-data">
          <div class="red pi-fz-54 pi-text-left">
            <span class="pi-fz-24 pi-fw-800">CMMI</span>5
          </div>
          <div class="biz-name pi-fz-16 pi-text-left">权威认证</div>
        </div> -->
      </div>
    </div>
    <div
      class="row-3-right pi-justify-center"
      :class="isMobile || show ? 'animate__animated animate__fadeInUp' : 'hide'"
    >
      <div
        class="biz-tab-item pi-flex-column pi-align-start pi-pd-top-56 pi-pd-lr-46 pi-mg-right-22"
      >
        <i
          class="iconfont icondengpao tab-icon red pi-mg-bottom-28"
          style="font-size: 50px"
        ></i>
        <span class="tab-title">数字化服务</span>
        <span class="tab-desc pi-mg-top-32 pi-text-left"
          >用数字科技助力企业数字化转型，实现持续为企业贡献新增长。</span
        >
      </div>
      <div
        class="biz-tab-item pi-flex-column pi-align-start pi-pd-top-56 pi-pd-lr-46 pi-mg-right-22"
      >
        <i
          class="iconfont iconcrew_tech tab-icon pi-fz-44 red pi-mg-bottom-28"
          style="font-size: 44px"
        ></i>
        <span class="tab-title">数字化产品与方案</span>
        <span class="tab-desc pi-mg-top-32 pi-text-left"
          >洞察行业态势，聚焦客户需求，赋能企业数字化转型升级。</span
        >
      </div>
      <div
        class="biz-tab-item pi-flex-column pi-pd-top-56 pi-align-start pi-pd-lr-46"
      >
        <i
          class="iconfont iconjiaoyu1 tab-icon pi-fz-34 red pi-mg-bottom-28"
          style="font-size: 34px"
        ></i>
        <span class="tab-title">互联网+教育</span>
        <span class="tab-desc pi-mg-top-32 pi-text-left"
          >针对在线教育行业的应用场景，海量数据、交互式多样的特点，推出不同垂直行业的一站式解决方案。</span
        >
      </div>
    </div>
  </section>
</template>

<script>
import DigitRoll from "@huoyu/vue-digitroll";
import { isMobile } from "@/utils";
export default {
  data() {
    return {
      isMobile: isMobile(),
      img_show: false,
    };
  },
  methods: {
    loadInit() {
      return this.$refs.row3;
    },
  },
  components: {
    DigitRoll,
  },
  watch: {
    show: {
      deep: true,
      handler(val) {
        console.log(val);
      },
    },
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style>
.d-roll-wrapper {
  margin: 0 !important;
}

.d-roll-item > .d-roll-bar > div {
  font-weight: bold;
  font-size: 54px !important;
  color: #e60012;
}
</style>
<style lang="scss" scoped>
.tab-desc{
  font-size: 1vw;
}
.tab-title{
  font-size: 1.4vw;
}
.row-3-right {
  margin-left: 70px;
}
.biz-tab-item:hover {
  border: 1px solid #e5e5e5;
  border-top: 6px solid #e60012;
  box-shadow: 0px 0px 20px 0px rgba(236, 214, 214, 0.35);
  background: #ffffff;
}
.biz-tab-item {
  transition: all 0.5s;
  width: 18vw;
  min-height: 320px;
  padding-bottom: 20px;
  background: #f9f9f9;
}
.hide {
  opacity: 0;
}
.red {
  color: #e60012;
  span {
    color: #e60012;
  }
}
.biz-name {
  white-space: nowrap;
}
.biz-desc-content {
  // display: grid;
  // grid-template-columns: 50% 50%;
  // grid-template-rows: 50% 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/row_3/index.vue